const React = require('react');
const { default: MuiTextField } = require('@mui/material/TextField');
const { default: Styled, css } = require('styled-components');
const { singleLineFieldStyles } = require('./singleLineFieldStyles');
const FieldResolver = require('./useResolvedFieldController');
const AgeUtils = require('./ageUtils');

const internals = {};

internals.resolveAgeValue = (birthdate) => {

    const age = AgeUtils.getAge(birthdate);

    return age === null ? '' : String(age);
};

module.exports = function AgeField(props) {
    const { SingleLineAgeField } = internals;

    const {
        field = {},
        fieldName = field.name,
        label = field.label || 'Age',
        maxAge = field.maxAge || AgeUtils.MAX_AGE,
        methods = {},
        minAge = field.minAge || AgeUtils.MIN_AGE,
        onBlur,
        onChange,
        onFocus,
        setValue,
        textFieldProps = {},
        useField: requestedUseFieldHook,
        value
    } = props;

    const fieldController = FieldResolver.useResolvedField({
        field,
        fieldName,
        methods,
        requestedUseFieldHook
    });
    const resolvedValue = typeof value === 'undefined'
        ? fieldController.getValue()
        : value;
    const resolvedTextFieldProps = fieldController.getTextFieldProps?.(textFieldProps) || textFieldProps;
    const {
        fieldStyles,
        ...resolvedDomTextFieldProps
    } = resolvedTextFieldProps;
    const hasError = !!resolvedTextFieldProps.error;
    const helperText = resolvedTextFieldProps.helperText;
    const setFieldValue = typeof setValue === 'function'
        ? setValue
        : fieldController.setValue;

    return <SingleLineAgeField
        fullWidth
        label={label}
        type='number'
        value={internals.resolveAgeValue(resolvedValue)}
        inputProps={{
            ...(resolvedTextFieldProps.inputProps || {}),
            min: minAge,
            max: maxAge,
            'aria-invalid': hasError || undefined
        }}
        {...resolvedDomTextFieldProps}
        $fieldStyles={fieldStyles}
        error={hasError}
        helperText={helperText}
        onBlur={(event) => {
            fieldController.onBlur?.(event);
            onBlur?.(event);
        }}
        onChange={(event) => {
            const ageValue = event.target.value;

            if (ageValue === '') {
                setFieldValue(null, event);
                onChange?.(null, event);
                return;
            }

            const parsedAge = Number(ageValue);

            if (!Number.isFinite(parsedAge)) {
                return;
            }

            const birthdate = AgeUtils.buildBirthdateFromAge(parsedAge);

            setFieldValue(birthdate, event);
            onChange?.(birthdate, event);
        }}
        onFocus={(event) => {
            fieldController.onFocus?.(event);
            onFocus?.(event);
        }}
    />;
};

internals.SingleLineAgeField = Styled(MuiTextField)`
    ${singleLineFieldStyles}
    ${({ $fieldStyles }) => css`${$fieldStyles || ''}`}
`;

module.exports.internals = internals;
